import React, { useEffect } from "react";
import { HomePage} from "./homePage.js";
import { WaterBar } from "./WaterTracker.js";
import { Profile } from "./Profile.js";
import { SignInPage } from "./SignInPage.js";
import { SummaryPage, BarChart } from "./Summary.js";
import { useState } from "react";
import { Route, Routes, Navigate, NavLink, Outlet, useNavigate } from 'react-router-dom';
import {getAuth, onAuthStateChanged, signOut} from 'firebase/auth'
import { Alert } from 'react-bootstrap';


function App(props) {
  const [alertMessage, setAlertMessage] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  // console.log('starting');
  useEffect(() => {
    const auth = getAuth();
    const authoOffFunction = onAuthStateChanged(auth, (firebaseUser) => {
      if(firebaseUser) {
        // console.log("signed in as", firebaseUser.uid);
        setCurrentUser(firebaseUser.uid);
        // console.log('has been set to ' + currentUser);
      } else {
        // console.log("signed out");
        setCurrentUser(null);
      }

    })
    function cleanup() {
      authoOffFunction();
    }
    return cleanup;
  }, [])

  function RequireAuth(props) {
    //setUserIsLoggedIn(currentUser != null);
    if (currentUser == null) { //if no user, send to sign in
      // console.log("No user signed in");
      return <Navigate to="/signin" />;
    }
    else { //otherwise, show the child route content
      // console.log(currentUser, " is signed in");
      return <Outlet />
    }
  }

  const handleSignOut = (event) => {
    signOut(getAuth());
  }

  return(
    <div>
      <header>
        <div>
          <nav>
            <ul>
              <li><NavLink to="/home" className="homeLink">
                  <img src="img/home.png" alt="home logo"></img>
                </NavLink></li>
              <li><NavLink to="/profile" className="profileLink"><img src="img/profile-small.png" alt="profile logo"></img></NavLink></li>
              <li><NavLink to="/summary" className="summaryLink"><img src="img/summary.png" alt="data logo"></img></NavLink></li>
              <li><button onClick={handleSignOut} className="navButton" className="logoutLink" aria-label="Signs user out"><img src="img/logout.png" alt="logout logo"></img></button></li>
            </ul>
          </nav>
          {/* display any error messages as dismissible alerts */}
          {alertMessage &&
          <Alert variant="danger" dismissible onClose={() => setAlertMessage(null)}>{alertMessage}</Alert>
          }
        </div>
        <img src="img/logo.png" alt="Sprout Logo"></img>
        <div></div>
      </header>
      <div>
        <Routes>
            {/* protected routes */}
            <Route element={<RequireAuth />}>
              <Route path="home" element={<HomePage uid={currentUser} setAlertMessage={setAlertMessage}/>} />
              <Route path="profile" element={<Profile uid={currentUser} setAlertMessage={setAlertMessage}/>} />
              <Route path="summary" element={<SummaryPage uid={currentUser} setAlertMessage={setAlertMessage}/>} />
              <Route path="*" element={<Navigate to="/home" />} />
            </Route>
            {/* public routes */}
            <Route path="signin" element={<SignInPage />}>
              <Route path="*" element={<HomePage />} />
            </Route>
        </Routes>
      </div>
      <footer>
        © 2022 Sabrina Burka, Nathan Limono, Drew Grimstead, Christopher Ku. Images drawn by Sabrina Burka
      </footer>
    </div>
  )
}

export default App;